// KR 종목 섹터 마스터 (WICS 업종 대분류).
// 출처: 비중계산(모모용)_260805.xlsx '섹터' 시트 (WICS, 2026-05-06 기준).
// 키=6자리 종목코드. 새 마스터 받으면 이 파일만 재생성.
export const KR_SECTOR = {
  "000020": "건강관리",
  "000040": "금융",
  "000050": "경기관련소비재",
  "000070": "IT",
  "000080": "산업재",
  "000090": "건강관리",
  "000100": "건강관리",
  "000120": "산업재",
  "000130": "필수소비재",
  "000140": "필수소비재",
  "000150": "경기관련소비재",
  "000180": "소재",
  "000210": "소재",
  "000220": "건강관리",
  "000230": "건강관리",
  "000240": "경기관련소비재",
  "000250": "건강관리",
  "000270": "경기관련소비재",
  "000300": "금융",
  "000320": "산업재",
  "000370": "금융",
  "000390": "산업재",
  "000400": "금융",
  "000410": "금융",
  "000430": "경기관련소비재",
  "000440": "금융",
  "000480": "소재",
  "000490": "산업재",
  "000500": "산업재",
  "000520": "건강관리",
  "000540": "금융",
  "000590": "소재",
  "000640": "건강관리",
  "000650": "산업재",
  "000660": "IT",
  "000670": "IT",
  "000680": "금융",
  "000700": "산업재",
  "000710": "금융",
  "000720": "금융",
  "000760": "소재",
  "000810": "금융",
  "000850": "산업재",
  "000860": "산업재",
  "000880": "금융",
  "000890": "필수소비재",
  "000910": "금융",
  "000930": "금융",
  "000950": "경기관련소비재",
  "000960": "금융",
  "000970": "금융",
  "000980": "금융",
  "000990": "금융",
  "001000": "금융",
  "001010": "금융",
  "001020": "소재",
  "001040": "산업재",
  "001050": "금융",
  "001060": "건강관리",
  "001070": "경기관련소비재",
  "001080": "소재",
  "001120": "산업재",
  "001130": "필수소비재",
  "001200": "금융",
  "001210": "IT",
  "001230": "소재",
  "001250": "산업재",
  "001260": "건강관리",
  "001270": "금융",
  "001290": "금융",
  "001340": "소재",
  "001360": "건강관리",
  "001380": "경기관련소비재",
  "001390": "경기관련소비재",
  "001420": "경기관련소비재",
  "001430": "소재",
  "001440": "산업재",
  "001450": "금융",
  "001460": "경기관련소비재",
  "001470": "산업재",
  "001500": "금융",
  "001510": "금융",
  "001520": "산업재",
  "001530": "경기관련소비재",
  "001540": "건강관리",
  "001550": "소재",
  "001560": "소재",
  "001570": "소재",
  "001620": "경기관련소비재",
  "001630": "건강관리",
  "001680": "필수소비재",
  "001720": "금융",
  "001740": "산업재",
  "001750": "금융",
  "001770": "소재",
  "001780": "소재",
  "001790": "필수소비재",
  "001800": "필수소비재",
  "001810": "소재",
  "001820": "IT",
  "001840": "산업재",
  "001940": "소재",
  "002020": "산업재",
  "002030": "산업재",
  "002070": "경기관련소비재",
  "002100": "소재",
  "002140": "필수소비재",
  "002150": "산업재",
  "002170": "경기관련소비재",
  "002200": "소재",
  "002210": "건강관리",
  "002220": "소재",
  "002230": "IT",
  "002240": "소재",
  "002290": "산업재",
  "002310": "소재",
  "002320": "산업재",
  "002350": "경기관련소비재",
  "002360": "소재",
  "002380": "산업재",
  "002390": "건강관리",
  "002410": "산업재",
  "002420": "경기관련소비재",
  "002450": "경기관련소비재",
  "002460": "산업재",
  "002600": "필수소비재",
  "002620": "건강관리",
  "002630": "건강관리",
  "002680": "필수소비재",
  "002690": "소재",
  "002700": "경기관련소비재",
  "002710": "소재",
  "002720": "건강관리",
  "002760": "필수소비재",
  "002780": "산업재",
  "002790": "경기관련소비재",
  "002800": "건강관리",
  "002810": "소재",
  "002820": "소재",
  "002840": "소재",
  "002870": "소재",
  "002880": "경기관련소비재",
  "002900": "산업재",
  "002920": "경기관련소비재",
  "002960": "소재",
  "002990": "산업재",
  "003000": "건강관리",
  "003010": "산업재",
  "003030": "소재",
  "003060": "건강관리",
  "003070": "산업재",
  "003080": "소재",
  "003090": "건강관리",
  "003100": "산업재",
  "003120": "건강관리",
  "003160": "IT",
  "003200": "경기관련소비재",
  "003220": "건강관리",
  "003230": "필수소비재",
  "003240": "소재",
  "003280": "산업재",
  "003300": "산업재",
  "003310": "필수소비재",
  "003350": "경기관련소비재",
  "003380": "필수소비재",
  "003460": "금융",
  "003470": "금융",
  "003480": "유틸리티",
  "003490": "산업재",
  "003520": "건강관리",
  "003530": "금융",
  "003540": "금융",
  "003550": "산업재",
  "003570": "경기관련소비재",
  "003580": "경기관련소비재",
  "003610": "경기관련소비재",
  "003620": "경기관련소비재",
  "003650": "소재",
  "003670": "소재",
  "003680": "필수소비재",
  "003690": "금융",
  "003720": "소재",
  "003780": "소재",
  "003800": "산업재",
  "003830": "소재",
  "003850": "건강관리",
  "003920": "필수소비재",
  "003960": "필수소비재",
  "004000": "소재",
  "004020": "소재",
  "004060": "경기관련소비재",
  "004080": "건강관리",
  "004090": "소재",
  "004100": "경기관련소비재",
  "004140": "산업재",
  "004150": "산업재",
  "004170": "경기관련소비재",
  "004250": "소재",
  "004270": "IT",
  "004310": "건강관리",
  "004360": "산업재",
  "004370": "필수소비재",
  "004380": "산업재",
  "004410": "필수소비재",
  "004430": "소재",
  "004440": "산업재",
  "004450": "소재",
  "004490": "경기관련소비재",
  "004540": "소재",
  "004560": "소재",
  "004590": "필수소비재",
  "004650": "필수소비재",
  "004690": "유틸리티",
  "004700": "경기관련소비재",
  "004710": "IT",
  "004720": "건강관리",
  "004770": "IT",
  "004780": "소재",
  "004800": "산업재",
  "004830": "경기관련소비재",
  "004840": "소재",
  "004870": "산업재",
  "004890": "소재",
  "004910": "산업재",
  "004920": "IT",
  "004960": "산업재",
  "004970": "필수소비재",
  "004980": "산업재",
  "004990": "산업재",
  "005010": "소재",
  "005030": "경기관련소비재",
  "005070": "소재",
  "005090": "에너지",
  "005110": "금융",
  "005160": "소재",
  "005180": "필수소비재",
  "005250": "건강관리",
  "005290": "IT",
  "005300": "필수소비재",
  "005320": "경기관련소비재",
  "005360": "경기관련소비재",
  "005380": "경기관련소비재",
  "005420": "소재",
  "005430": "산업재",
  "005440": "산업재",
  "005490": "소재",
  "005500": "건강관리",
  "005610": "필수소비재",
  "005670": "필수소비재",
  "005680": "IT",
  "005690": "소재",
  "005710": "경기관련소비재",
  "005720": "경기관련소비재",
  "005740": "필수소비재",
  "005750": "산업재",
  "005800": "경기관련소비재",
  "005810": "소재",
  "005820": "소재",
  "005830": "금융",
  "005850": "경기관련소비재",
  "005860": "필수소비재",
  "005870": "산업재",
  "005880": "산업재",
  "005930": "IT",
  "005940": "금융",
  "005950": "소재",
  "005960": "산업재",
  "005990": "필수소비재",
  "006040": "필수소비재",
  "006050": "산업재",
  "006060": "경기관련소비재",
  "006090": "필수소비재",
  "006110": "소재",
  "006120": "에너지",
  "006140": "건강관리",
  "006200": "IT",
  "006220": "금융",
  "006260": "산업재",
  "006280": "건강관리",
  "006340": "산업재",
  "006360": "산업재",
  "006370": "경기관련소비재",
  "006380": "소재",
  "006400": "IT",
  "006490": "커뮤니케이션서비스",
  "006570": "산업재",
  "006620": "건강관리",
  "006650": "소재",
  "006660": "경기관련소비재",
  "006730": "경기관련소비재",
  "006740": "소재",
  "006800": "금융",
  "006840": "소재",
  "006880": "필수소비재",
  "006890": "소재",
  "006910": "산업재",
  "006920": "산업재",
  "006980": "필수소비재",
  "007070": "경기관련소비재",
  "007110": "산업재",
  "007120": "IT",
  "007160": "필수소비재",
  "007210": "산업재",
  "007280": "소재",
  "007310": "필수소비재",
  "007330": "금융",
  "007340": "경기관련소비재",
  "007370": "건강관리",
  "007390": "건강관리",
  "007460": "건강관리",
  "007530": "경기관련소비재",
  "007540": "필수소비재",
  "007570": "건강관리",
  "007590": "소재",
  "007610": "산업재",
  "007660": "IT",
  "007680": "산업재",
  "007690": "소재",
  "007700": "경기관련소비재",
  "007720": "경기관련소비재",
  "007770": "소재",
  "007810": "IT",
  "007820": "산업재",
  "007860": "경기관련소비재",
  "007980": "경기관련소비재",
  "008040": "필수소비재",
  "008060": "IT",
  "008250": "산업재",
  "008260": "산업재",
  "008290": "경기관련소비재",
  "008350": "소재",
  "008370": "소재",
  "008420": "소재",
  "008470": "산업재",
  "008490": "건강관리",
  "008500": "경기관련소비재",
  "008600": "경기관련소비재",
  "008700": "IT",
  "008730": "소재",
  "008770": "경기관련소비재",
  "008830": "산업재",
  "008870": "소재",
  "008930": "건강관리",
  "008970": "소재",
  "009070": "산업재",
  "009140": "IT",
  "009150": "IT",
  "009160": "소재",
  "009180": "산업재",
  "009190": "소재",
  "009200": "소재",
  "009240": "산업재",
  "009270": "경기관련소비재",
  "009290": "건강관리",
  "009300": "건강관리",
  "009310": "IT",
  "009320": "경기관련소비재",
  "009410": "산업재",
  "009420": "건강관리",
  "009440": "산업재",
  "009450": "경기관련소비재",
  "009460": "소재",
  "009470": "IT",
  "009520": "소재",
  "009540": "산업재",
  "009580": "소재",
  "009620": "소재",
  "009680": "경기관련소비재",
  "009730": "소재",
  "009770": "필수소비재",
  "009780": "필수소비재",
  "009810": "경기관련소비재",
  "009830": "에너지",
  "009900": "경기관련소비재",
  "009970": "경기관련소비재",
  "010040": "소재",
  "010060": "소재",
  "010100": "경기관련소비재",
  "010120": "산업재",
  "010130": "소재",
  "010140": "산업재",
  "010170": "IT",
  "010240": "산업재",
  "010280": "IT",
  "010400": "산업재",
  "010470": "커뮤니케이션서비스",
  "010580": "경기관련소비재",
  "010640": "소재",
  "010660": "산업재",
  "010690": "경기관련소비재",
  "010770": "경기관련소비재",
  "010780": "산업재",
  "010820": "산업재",
  "010950": "에너지",
  "010960": "산업재",
  "011000": "건강관리",
  "011040": "건강관리",
  "011070": "IT",
  "011080": "경기관련소비재",
  "011090": "산업재",
  "011150": "필수소비재",
  "011170": "소재",
  "011200": "산업재",
  "011210": "경기관련소비재",
  "011230": "IT",
  "011280": "소재",
  "011300": "경기관련소비재",
  "011320": "경기관련소비재",
  "011330": "경기관련소비재",
  "011370": "산업재",
  "011390": "산업재",
  "011420": "경기관련소비재",
  "011500": "소재",
  "011560": "산업재",
  "011690": "IT",
  "011700": "산업재",
  "011760": "산업재",
  "011780": "소재",
  "011790": "소재",
  "011810": "산업재",
  "011930": "IT",
  "012030": "IT",
  "012160": "소재",
  "012170": "커뮤니케이션서비스",
  "012200": "경기관련소비재",
  "012210": "산업재",
  "012280": "경기관련소비재",
  "012320": "소재",
  "012330": "경기관련소비재",
  "012340": "IT",
  "012450": "산업재",
  "012510": "IT",
  "012610": "소재",
  "012620": "소재",
  "012630": "산업재",
  "012690": "필수소비재",
  "012700": "에너지",
  "012750": "산업재",
  "012790": "건강관리",
  "012800": "소재",
  "012860": "경기관련소비재",
  "013000": "소재",
  "013030": "산업재",
  "013120": "산업재",
  "013310": "경기관련소비재",
  "013360": "산업재",
  "013520": "경기관련소비재",
  "013570": "경기관련소비재",
  "013580": "산업재",
  "013700": "산업재",
  "013720": "경기관련소비재",
  "013810": "산업재",
  "013870": "경기관련소비재",
  "013890": "산업재",
  "013990": "경기관련소비재",
  "014100": "경기관련소비재",
  "014130": "산업재",
  "014160": "소재",
  "014190": "소재",
  "014280": "산업재",
  "014440": "소재",
  "014470": "경기관련소비재",
  "014530": "에너지",
  "014570": "건강관리",
  "014580": "소재",
  "014620": "산업재",
  "014680": "소재",
  "014710": "필수소비재",
  "014790": "산업재",
  "014820": "소재",
  "014830": "소재",
  "014910": "IT",
  "014940": "산업재",
  "014950": "건강관리",
  "014970": "소재",
  "014990": "경기관련소비재",
  "015020": "금융",
  "015230": "산업재",
  "015260": "IT",
  "015360": "유틸리티",
  "015590": "산업재",
  "015710": "IT",
  "015750": "경기관련소비재",
  "015760": "유틸리티",
  "015860": "산업재",
  "015890": "소재",
  "016090": "경기관련소비재",
  "016100": "소재",
  "016250": "산업재",
  "016360": "금융",
  "016380": "소재",
  "016450": "경기관련소비재",
  "016580": "건강관리",
  "016590": "소재",
  "016600": "금융",
  "016610": "금융",
  "016670": "IT",
  "016710": "유틸리티",
  "016740": "경기관련소비재",
  "016790": "필수소비재",
  "016800": "산업재",
  "016880": "커뮤니케이션서비스",
  "016920": "IT",
  "017000": "산업재",
  "017040": "산업재",
  "017180": "건강관리",
  "017250": "IT",
  "017370": "경기관련소비재",
  "017390": "유틸리티",
  "017480": "소재",
  "017510": "산업재",
  "017550": "산업재",
  "017650": "소재",
  "017670": "커뮤니케이션서비스",
  "017800": "산업재",
  "017810": "필수소비재",
  "017860": "소재",
  "017890": "소재",
  "017900": "IT",
  "017940": "유틸리티",
  "017960": "산업재",
  "018000": "에너지",
  "018120": "필수소비재",
  "018250": "경기관련소비재",
  "018260": "IT",
  "018290": "경기관련소비재",
  "018310": "산업재",
  "018470": "소재",
  "018500": "경기관련소비재",
  "018620": "건강관리",
  "018670": "유틸리티",
  "018680": "건강관리",
  "018700": "경기관련소비재",
  "018880": "경기관련소비재",
  "019010": "경기관련소비재",
  "019170": "건강관리",
  "019180": "경기관련소비재",
  "019210": "산업재",
  "019490": "IT",
  "019540": "경기관련소비재",
  "019550": "금융",
  "019570": "금융",
  "019660": "경기관련소비재",
  "019680": "경기관련소비재",
  "019770": "경기관련소비재",
  "019990": "산업재",
  "020000": "경기관련소비재",
  "020120": "커뮤니케이션서비스",
  "020150": "IT",
  "020180": "IT",
  "020400": "경기관련소비재",
  "020560": "산업재",
  "020710": "경기관련소비재",
  "020760": "IT",
  "021040": "소재",
  "021050": "소재",
  "021080": "금융",
  "021240": "경기관련소비재",
  "021320": "산업재",
  "021650": "경기관련소비재",
  "021820": "경기관련소비재",
  "021880": "금융",
  "022100": "IT",
  "022220": "산업재",
  "023000": "경기관련소비재",
  "023150": "필수소비재",
  "023160": "산업재",
  "023350": "산업재",
  "023410": "산업재",
  "023440": "소재",
  "023450": "소재",
  "023530": "경기관련소비재",
  "023590": "금융",
  "023600": "소재",
  "023760": "금융",
  "023770": "커뮤니케이션서비스",
  "023790": "소재",
  "023800": "경기관련소비재",
  "023810": "경기관련소비재",
  "023900": "소재",
  "023910": "건강관리",
  "023960": "산업재",
  "024060": "에너지",
  "024070": "소재",
  "024090": "소재",
  "024110": "금융",
  "024120": "경기관련소비재",
  "024720": "경기관련소비재",
  "024740": "경기관련소비재",
  "024800": "산업재",
  "024830": "경기관련소비재",
  "024840": "산업재",
  "024850": "IT",
  "024880": "산업재",
  "024890": "경기관련소비재",
  "024900": "경기관련소비재",
  "024910": "경기관련소비재",
  "024940": "경기관련소비재",
  "024950": "경기관련소비재",
  "025000": "소재",
  "025320": "IT",
  "025440": "경기관련소비재",
  "025530": "경기관련소비재",
  "025540": "경기관련소비재",
  "025550": "소재",
  "025560": "IT",
  "025620": "경기관련소비재",
  "025750": "산업재",
  "025770": "IT",
  "025820": "소재",
  "025860": "소재",
  "025870": "필수소비재",
  "025880": "필수소비재",
  "025890": "소재",
  "025900": "산업재",
  "025950": "산업재",
  "025980": "경기관련소비재",
  "026040": "경기관련소비재",
  "026150": "산업재",
  "026890": "금융",
  "026910": "소재",
  "026940": "소재",
  "026960": "필수소비재",
  "027040": "IT",
  "027050": "경기관련소비재",
  "027360": "금융",
  "027410": "소재",
  "027580": "소재",
  "027710": "필수소비재",
  "027740": "필수소비재",
  "027830": "금융",
  "027970": "소재",
  "028050": "산업재",
  "028080": "IT",
  "028100": "산업재",
  "028260": "산업재",
  "028300": "건강관리",
  "028670": "산업재",
  "029460": "IT",
  "029480": "IT",
  "029530": "IT",
  "029780": "금융",
  "030000": "커뮤니케이션서비스",
  "030190": "산업재",
  "030200": "커뮤니케이션서비스",
  "030210": "금융",
  "030350": "커뮤니케이션서비스",
  "030520": "IT",
  "030530": "IT",
  "030610": "금융",
  "030720": "필수소비재",
  "030960": "산업재",
  "031210": "금융",
  "031310": "IT",
  "031330": "IT",
  "031430": "경기관련소비재",
  "031440": "경기관련소비재",
  "031510": "경기관련소비재",
  "031820": "IT",
  "031860": "IT",
  "031980": "IT",
  "032080": "경기관련소비재",
  "032190": "금융",
  "032280": "산업재",
  "032300": "건강관리",
  "032350": "경기관련소비재",
  "032500": "IT",
  "032540": "IT",
  "032560": "소재",
  "032580": "IT",
  "032620": "건강관리",
  "032640": "커뮤니케이션서비스",
  "032680": "IT",
  "032750": "IT",
  "032790": "IT",
  "032800": "커뮤니케이션서비스",
  "032820": "산업재",
  "032830": "금융",
  "032850": "건강관리",
  "032860": "경기관련소비재",
  "032940": "경기관련소비재",
  "032960": "IT",
  "032980": "산업재",
  "033050": "산업재",
  "033100": "산업재",
  "033130": "IT",
  "033160": "IT",
  "033170": "IT",
  "033200": "IT",
  "033230": "IT",
  "033240": "IT",
  "033250": "경기관련소비재",
  "033270": "건강관리",
  "033290": "산업재",
  "033310": "경기관련소비재",
  "033320": "IT",
  "033340": "경기관련소비재",
  "033500": "소재",
  "033530": "경기관련소비재",
  "033540": "산업재",
  "033560": "금융",
  "033640": "IT",
  "033780": "필수소비재",
  "033790": "IT",
  "033830": "커뮤니케이션서비스",
  "033920": "필수소비재",
  "034020": "산업재",
  "034120": "커뮤니케이션서비스",
  "034220": "IT",
  "034230": "경기관련소비재",
  "034310": "IT",
  "034590": "유틸리티",
  "034730": "에너지",
  "034810": "소재",
  "034830": "금융",
  "034940": "건강관리",
  "034950": "산업재",
  "035000": "커뮤니케이션서비스",
  "035080": "경기관련소비재",
  "035150": "경기관련소비재",
  "035200": "산업재",
  "035250": "경기관련소비재",
  "035290": "경기관련소비재",
  "035420": "커뮤니케이션서비스",
  "035460": "산업재",
  "035510": "IT",
  "035600": "IT",
  "035610": "건강관리",
  "035620": "커뮤니케이션서비스",
  "035720": "커뮤니케이션서비스",
  "035760": "커뮤니케이션서비스",
  "035810": "필수소비재",
  "035890": "산업재",
  "035900": "커뮤니케이션서비스",
  "036000": "커뮤니케이션서비스",
  "036010": "IT",
  "036030": "경기관련소비재",
  "036090": "IT",
  "036120": "산업재",
  "036170": "IT",
  "036190": "산업재",
  "036200": "IT",
  "036220": "건강관리",
  "036420": "커뮤니케이션서비스",
  "036460": "유틸리티",
  "036480": "건강관리",
  "036530": "경기관련소비재",
  "036540": "IT",
  "036560": "산업재",
  "036570": "커뮤니케이션서비스",
  "036580": "필수소비재",
  "036620": "경기관련소비재",
  "036630": "커뮤니케이션서비스",
  "036640": "소재",
  "036670": "소재",
  "036690": "IT",
  "036710": "IT",
  "036800": "산업재",
  "036810": "IT",
  "036830": "IT",
  "036890": "산업재",
  "036930": "IT",
  "037030": "IT",
  "037070": "경기관련소비재",
  "037230": "소재",
  "037270": "커뮤니케이션서비스",
  "037330": "IT",
  "037350": "산업재",
  "037370": "소재",
  "037400": "IT",
  "037440": "산업재",
  "037460": "IT",
  "037560": "커뮤니케이션서비스",
  "037710": "경기관련소비재",
  "037760": "소재",
  "037950": "IT",
  "038010": "산업재",
  "038060": "IT",
  "038070": "건강관리",
  "038110": "경기관련소비재",
  "038290": "건강관리",
  "038390": "산업재",
  "038460": "IT",
  "038500": "산업재",
  "038530": "IT",
  "038540": "금융",
  "038620": "산업재",
  "038680": "IT",
  "038870": "에너지",
  "038880": "경기관련소비재",
  "038950": "IT",
  "039010": "IT",
  "039020": "산업재",
  "039030": "IT",
  "039130": "경기관련소비재",
  "039200": "건강관리",
  "039240": "소재",
  "039290": "IT",
  "039310": "IT",
  "039340": "커뮤니케이션서비스",
  "039420": "IT",
  "039440": "IT",
  "039490": "금융",
  "039560": "IT",
  "039570": "산업재",
  "039610": "산업재",
  "039740": "경기관련소비재",
  "039830": "경기관련소비재",
  "039840": "건강관리",
  "039860": "건강관리",
  "039980": "IT",
  "040160": "IT",
  "040300": "커뮤니케이션서비스",
  "040350": "IT",
  "040420": "경기관련소비재",
  "040610": "경기관련소비재",
  "040910": "IT",
  "041020": "경기관련소비재",
  "041190": "금융",
  "041440": "산업재",
  "041460": "IT",
  "041510": "커뮤니케이션서비스",
  "041520": "IT",
  "041590": "산업재",
  "041650": "경기관련소비재",
  "041830": "건강관리",
  "041910": "건강관리",
  "041920": "건강관리",
  "041930": "경기관련소비재",
  "041960": "건강관리",
  "042000": "IT",
  "042040": "소재",
  "042110": "IT",
  "042370": "IT",
  "042420": "커뮤니케이션서비스",
  "042500": "IT",
  "042510": "IT",
  "042520": "건강관리",
  "042600": "경기관련소비재",
  "042660": "산업재",
  "042700": "IT",
  "042940": "산업재",
  "043090": "IT",
  "043100": "건강관리",
  "043150": "건강관리",
  "043200": "에너지",
  "043220": "산업재",
  "043260": "IT",
  "043340": "산업재",
  "043360": "IT",
  "043370": "경기관련소비재",
  "043590": "IT",
  "043610": "커뮤니케이션서비스",
  "043650": "필수소비재",
  "043710": "건강관리",
  "043910": "산업재",
  "044180": "산업재",
  "044340": "경기관련소비재",
  "044380": "IT",
  "044450": "산업재",
  "044480": "커뮤니케이션서비스",
  "044490": "에너지",
  "044780": "산업재",
  "044820": "건강관리",
  "044960": "건강관리",
  "044990": "IT",
  "045060": "소재",
  "045100": "IT",
  "045300": "IT",
  "045340": "산업재",
  "045390": "IT",
  "045510": "IT",
  "045520": "IT",
  "045660": "IT",
  "045970": "IT",
  "046070": "경기관련소비재",
  "046120": "에너지",
  "046210": "건강관리",
  "046310": "IT",
  "046390": "커뮤니케이션서비스",
  "046440": "IT",
  "046890": "IT",
  "046940": "산업재",
  "046970": "IT",
  "047040": "산업재",
  "047050": "산업재",
  "047080": "커뮤니케이션서비스",
  "047310": "IT",
  "047400": "경기관련소비재",
  "047560": "IT",
  "047770": "경기관련소비재",
  "047810": "산업재",
  "047820": "커뮤니케이션서비스",
  "047920": "건강관리",
  "048410": "경기관련소비재",
  "048430": "경기관련소비재",
  "048470": "소재",
  "048530": "건강관리",
  "048550": "커뮤니케이션서비스",
  "048770": "산업재",
  "048830": "소재",
  "048870": "건강관리",
  "048910": "커뮤니케이션서비스",
  "049070": "IT",
  "049080": "IT",
  "049120": "IT",
  "049180": "산업재",
  "049430": "산업재",
  "049470": "IT",
  "049480": "IT",
  "049520": "IT",
  "049550": "IT",
  "049630": "IT",
  "049720": "산업재",
  "049800": "산업재",
  "049830": "소재",
  "049950": "IT",
  "049960": "건강관리",
  "050090": "커뮤니케이션서비스",
  "050110": "IT",
  "050120": "경기관련소비재",
  "050760": "소재",
  "050860": "산업재",
  "050890": "IT",
  "050960": "IT",
  "051160": "경기관련소비재",
  "051360": "IT",
  "051370": "IT",
  "051380": "IT",
  "051390": "경기관련소비재",
  "051490": "산업재",
  "051500": "필수소비재",
  "051600": "유틸리티",
  "051630": "소재",
  "051780": "필수소비재",
  "051900": "경기관련소비재",
  "051910": "소재",
  "051980": "IT",
  "052020": "경기관련소비재",
  "052220": "커뮤니케이션서비스",
  "052260": "경기관련소비재",
  "052300": "산업재",
  "052330": "IT",
  "052400": "IT",
  "052420": "IT",
  "052460": "IT",
  "052600": "IT",
  "052690": "유틸리티",
  "052710": "IT",
  "052770": "커뮤니케이션서비스",
  "052790": "커뮤니케이션서비스",
  "052860": "IT",
  "052900": "IT",
  "053030": "건강관리",
  "053050": "유틸리티",
  "053060": "경기관련소비재",
  "053080": "산업재",
  "053160": "산업재",
  "053210": "커뮤니케이션서비스",
  "053260": "소재",
  "053270": "경기관련소비재",
  "053280": "경기관련소비재",
  "053290": "경기관련소비재",
  "053300": "IT",
  "053350": "IT",
  "053450": "IT",
  "053580": "IT",
  "053610": "IT",
  "053620": "필수소비재",
  "053690": "산업재",
  "053700": "경기관련소비재",
  "053800": "IT",
  "053950": "건강관리",
  "053980": "IT",
  "054040": "IT",
  "054050": "건강관리",
  "054090": "IT",
  "054180": "산업재",
  "054210": "IT",
  "054220": "IT",
  "054300": "산업재",
  "054410": "소재",
  "054450": "IT",
  "054540": "산업재",
  "054620": "IT",
  "054670": "건강관리",
  "054780": "커뮤니케이션서비스",
  "054800": "IT",
  "054920": "소재",
  "054930": "산업재",
  "054940": "IT",
  "054950": "건강관리",
  "055490": "IT",
  "055550": "금융",
  "056080": "산업재",
  "056090": "건강관리",
  "056190": "산업재",
  "056360": "IT",
  "056700": "IT",
  "056730": "산업재",
  "057030": "경기관련소비재",
  "057050": "경기관련소비재",
  "057540": "IT",
  "057680": "IT",
  "058110": "건강관리",
  "058400": "커뮤니케이션서비스",
  "058430": "소재",
  "058450": "커뮤니케이션서비스",
  "058470": "IT",
  "058610": "IT",
  "058630": "커뮤니케이션서비스",
  "058650": "소재",
  "058730": "산업재",
  "058820": "건강관리",
  "058850": "산업재",
  "058860": "산업재",
  "058970": "IT",
  "059090": "IT",
  "059100": "IT",
  "059120": "IT",
  "059210": "건강관리",
  "059270": "산업재",
  "060150": "산업재",
  "060230": "IT",
  "060240": "산업재",
  "060250": "IT",
  "060260": "산업재",
  "060280": "건강관리",
  "060310": "산업재",
  "060370": "산업재",
  "060380": "소재",
  "060480": "소재",
  "060540": "IT",
  "060560": "산업재",
  "060570": "커뮤니케이션서비스",
  "060590": "건강관리",
  "060720": "IT",
  "060850": "IT",
  "060900": "에너지",
  "060980": "경기관련소비재",
  "061040": "IT",
  "061090": "IT",
  "061250": "건강관리",
  "061970": "IT",
  "062040": "산업재",
  "062970": "IT",
  "063080": "커뮤니케이션서비스",
  "063160": "건강관리",
  "063170": "경기관련소비재",
  "063440": "커뮤니케이션서비스",
  "063570": "IT",
  "063760": "IT",
  "064090": "경기관련소비재",
  "064240": "경기관련소비재",
  "064260": "IT",
  "064290": "IT",
  "064350": "산업재",
  "064400": "IT",
  "064480": "IT",
  "064520": "IT",
  "064550": "건강관리",
  "064760": "IT",
  "064800": "경기관련소비재",
  "064820": "금융",
  "064850": "IT",
  "064960": "경기관련소비재",
  "065060": "경기관련소비재",
  "065130": "IT",
  "065150": "필수소비재",
  "065170": "건강관리",
  "065350": "경기관련소비재",
  "065370": "IT",
  "065420": "에너지",
  "065440": "IT",
  "065450": "산업재",
  "065500": "경기관련소비재",
  "065510": "건강관리",
  "065530": "커뮤니케이션서비스",
  "065570": "산업재",
  "065650": "IT",
  "065660": "건강관리",
  "065680": "IT",
  "065690": "IT",
  "065710": "산업재",
  "065770": "IT",
  "065950": "산업재",
  "066130": "경기관련소비재",
  "066310": "IT",
  "066360": "필수소비재",
  "066410": "IT",
  "066430": "소재",
  "066570": "IT",
  "066590": "경기관련소비재",
  "066620": "산업재",
  "066670": "IT",
  "066700": "건강관리",
  "066790": "커뮤니케이션서비스",
  "066900": "IT",
  "066910": "경기관련소비재",
  "066970": "IT",
  "066980": "산업재",
  "067000": "커뮤니케이션서비스",
  "067010": "IT",
  "067080": "건강관리",
  "067160": "커뮤니케이션서비스",
  "067170": "경기관련소비재",
  "067280": "경기관련소비재",
  "067290": "건강관리",
  "067310": "IT",
  "067370": "건강관리",
  "067390": "산업재",
  "067570": "경기관련소비재",
  "067630": "건강관리",
  "067730": "IT",
  "067770": "IT",
  "067830": "경기관련소비재",
  "067900": "산업재",
  "067920": "IT",
  "067990": "경기관련소비재",
  "068050": "커뮤니케이션서비스",
  "068100": "IT",
  "068240": "산업재",
  "068270": "건강관리",
  "068290": "커뮤니케이션서비스",
  "068330": "건강관리",
  "068760": "건강관리",
  "068790": "IT",
  "068930": "경기관련소비재",
  "068940": "산업재",
  "069080": "커뮤니케이션서비스",
  "069140": "산업재",
  "069260": "소재",
  "069330": "IT",
  "069410": "IT",
  "069460": "소재",
  "069510": "IT",
  "069540": "IT",
  "069620": "건강관리",
  "069640": "경기관련소비재",
  "069730": "소재",
  "069920": "경기관련소비재",
  "069960": "경기관련소비재",
  "070300": "IT",
  "070590": "IT",
  "070960": "경기관련소비재",
  "071050": "금융",
  "071090": "소재",
  "071200": "건강관리",
  "071280": "IT",
  "071320": "유틸리티",
  "071670": "산업재",
  "071840": "경기관련소비재",
  "071850": "경기관련소비재",
  "071950": "산업재",
  "071970": "산업재",
  "072020": "건강관리",
  "072130": "IT",
  "072470": "경기관련소비재",
  "072710": "필수소비재",
  "072770": "IT",
  "072870": "경기관련소비재",
  "072950": "IT",
  "072990": "IT",
  "073010": "산업재",
  "073110": "IT",
  "073190": "산업재",
  "073240": "경기관련소비재",
  "073490": "IT",
  "073540": "IT",
  "073560": "필수소비재",
  "073570": "IT",
  "073640": "산업재",
  "074430": "건강관리",
  "074600": "IT",
  "074610": "산업재",
  "075130": "IT",
  "075180": "경기관련소비재",
  "075580": "산업재",
  "075970": "소재",
  "076080": "산업재",
  "076610": "IT",
  "077360": "IT",
  "077500": "IT",
  "077970": "산업재",
  "078000": "IT",
  "078020": "금융",
  "078070": "IT",
  "078130": "소재",
  "078140": "건강관리",
  "078150": "IT",
  "078160": "건강관리",
  "078340": "커뮤니케이션서비스",
  "078350": "IT",
  "078520": "경기관련소비재",
  "078590": "경기관련소비재",
  "078600": "IT",
  "078860": "커뮤니케이션서비스",
  "078890": "IT",
  "078930": "에너지",
  "079000": "산업재",
  "079160": "커뮤니케이션서비스",
  "079170": "소재",
  "079190": "IT",
  "079370": "IT",
  "079430": "산업재",
  "079550": "산업재",
  "079650": "산업재",
  "079810": "IT",
  "079900": "산업재",
  "079940": "IT",
  "079950": "IT",
  "079960": "IT",
  "079970": "IT",
  "079980": "경기관련소비재",
  "080010": "경기관련소비재",
  "080160": "경기관련소비재",
  "080220": "IT",
  "080420": "경기관련소비재",
  "080470": "경기관련소비재",
  "080520": "IT",
  "080530": "경기관련소비재",
  "080580": "IT",
  "080720": "건강관리",
  "081000": "소재",
  "081150": "소재",
  "081180": "IT",
  "081580": "IT",
  "081660": "경기관련소비재",
  "082210": "IT",
  "082270": "IT",
  "082640": "금융",
  "082660": "경기관련소비재",
  "082740": "산업재",
  "082800": "건강관리",
  "082850": "IT",
  "082920": "IT",
  "083310": "IT",
  "083420": "소재",
  "083450": "IT",
  "083470": "IT",
  "083500": "IT",
  "083550": "경기관련소비재",
  "083640": "IT",
  "083650": "에너지",
  "083660": "경기관련소비재",
  "083790": "건강관리",
  "083930": "IT",
  "084010": "소재",
  "084110": "건강관리",
  "084180": "커뮤니케이션서비스",
  "084370": "IT",
  "084440": "경기관련소비재",
  "084650": "건강관리",
  "084670": "산업재",
  "084680": "경기관련소비재",
  "084690": "필수소비재",
  "084730": "IT",
  "084850": "IT",
  "084870": "경기관련소비재",
  "084990": "건강관리",
  "085310": "산업재",
  "085620": "금융",
  "085660": "건강관리",
  "085670": "IT",
  "085810": "산업재",
  "085910": "경기관련소비재",
  "086040": "건강관리",
  "086060": "건강관리",
  "086280": "산업재",
  "086390": "IT",
  "086450": "건강관리",
  "086520": "소재",
  "086670": "산업재",
  "086710": "경기관련소비재",
  "086790": "금융",
  "086820": "건강관리",
  "086890": "건강관리",
  "086900": "건강관리",
  "086960": "IT",
  "086980": "커뮤니케이션서비스",
  "087010": "건강관리",
  "087260": "경기관련소비재",
  "087600": "IT",
  "088130": "IT",
  "088260": "금융",
  "088280": "IT",
  "088290": "경기관련소비재",
  "088340": "IT",
  "088350": "금융",
  "088390": "경기관련소비재",
  "088790": "경기관련소비재",
  "088800": "IT",
  "088910": "필수소비재",
  "089010": "IT",
  "089030": "IT",
  "089140": "산업재",
  "089150": "IT",
  "089230": "커뮤니케이션서비스",
  "089470": "경기관련소비재",
  "089590": "산업재",
  "089600": "커뮤니케이션서비스",
  "089790": "IT",
  "089850": "IT",
  "089860": "산업재",
  "089890": "IT",
  "089970": "IT",
  "089980": "IT",
  "090080": "경기관련소비재",
  "090150": "경기관련소비재",
  "090350": "산업재",
  "090360": "산업재",
  "090370": "산업재",
  "090410": "산업재",
  "090430": "경기관련소비재",
  "090460": "IT",
  "090470": "IT",
  "090710": "산업재",
  "090850": "산업재",
  "091120": "IT",
  "091340": "IT",
  "091440": "IT",
  "091580": "IT",
  "091590": "산업재",
  "091700": "IT",
  "091810": "산업재",
  "091970": "소재",
  "092040": "건강관리",
  "092070": "IT",
  "092130": "산업재",
  "092190": "IT",
  "092200": "경기관련소비재",
  "092220": "IT",
  "092230": "소재",
  "092300": "IT",
  "092440": "산업재",
  "092460": "산업재",
  "092600": "IT",
  "092730": "경기관련소비재",
  "092780": "경기관련소비재",
  "092790": "소재",
  "092870": "IT",
  "093050": "경기관련소비재",
  "093190": "IT",
  "093240": "경기관련소비재",
  "093320": "IT",
  "093370": "소재",
  "093380": "경기관련소비재",
  "093520": "IT",
  "093640": "IT",
  "093920": "IT",
  "094170": "IT",
  "094280": "산업재",
  "094360": "IT",
  "094480": "IT",
  "094820": "산업재",
  "094840": "IT",
  "094850": "경기관련소비재",
  "094860": "커뮤니케이션서비스",
  "094940": "IT",
  "094970": "IT",
  "095190": "산업재",
  "095270": "산업재",
  "095340": "IT",
  "095500": "IT",
  "095570": "산업재",
  "095610": "IT",
  "095660": "커뮤니케이션서비스",
  "095700": "건강관리",
  "095720": "경기관련소비재",
  "095910": "에너지",
  "096240": "경기관련소비재",
  "096250": "IT",
  "096350": "산업재",
  "096530": "건강관리",
  "096610": "IT",
  "096630": "IT",
  "096690": "IT",
  "096760": "건강관리",
  "096770": "에너지",
  "096870": "IT",
  "097230": "산업재",
  "097520": "IT",
  "097780": "경기관련소비재",
  "097800": "IT",
  "097870": "소재",
  "097950": "필수소비재",
  "098070": "에너지",
  "098120": "IT",
  "098460": "IT",
  "098660": "경기관련소비재",
  "099190": "건강관리",
  "099220": "에너지",
  "099320": "산업재",
  "099390": "IT",
  "099410": "산업재",
  "099430": "건강관리",
  "099440": "산업재",
  "099520": "IT",
  "099750": "건강관리",
  "100030": "IT",
  "100090": "에너지",
  "100120": "건강관리",
  "100130": "에너지",
  "100220": "경기관련소비재",
  "100250": "경기관련소비재",
  "100590": "IT",
  "100660": "산업재",
  "100700": "건강관리",
  "100790": "금융",
  "100840": "에너지",
  "101000": "산업재",
  "101140": "IT",
  "101160": "IT",
  "101170": "산업재",
  "101240": "소재",
  "101330": "경기관련소비재",
  "101360": "소재",
  "101390": "IT",
  "101400": "IT",
  "101490": "IT",
  "101530": "필수소비재",
  "101670": "IT",
  "101680": "산업재",
  "101730": "커뮤니케이션서비스",
  "101930": "산업재",
  "101970": "에너지",
  "102120": "IT",
  "102260": "소재",
  "102370": "경기관련소비재",
  "102460": "건강관리",
  "102710": "IT",
  "102940": "건강관리",
  "103140": "소재",
  "103230": "산업재",
  "103590": "산업재",
  "103840": "필수소비재",
  "104040": "경기관련소비재",
  "104200": "커뮤니케이션서비스",
  "104460": "산업재",
  "104480": "소재",
  "104540": "건강관리",
  "104620": "경기관련소비재",
  "104700": "소재",
  "104830": "소재",
  "105330": "IT",
  "105550": "경기관련소비재",
  "105560": "금융",
  "105630": "경기관련소비재",
  "105740": "산업재",
  "105760": "산업재",
  "105840": "산업재",
  "106080": "IT",
  "106190": "건강관리",
  "106240": "IT",
  "106520": "IT",
  "107590": "소재",
  "107600": "IT",
  "107640": "산업재",
  "108230": "IT",
  "108320": "IT",
  "108380": "산업재",
  "108490": "산업재",
  "108670": "산업재",
  "108860": "건강관리",
  "109070": "산업재",
  "109080": "IT",
  "109610": "산업재",
  "109670": "경기관련소비재",
  "109740": "IT",
  "109820": "건강관리",
  "109860": "산업재",
  "109960": "건강관리",
  "110020": "필수소비재",
  "110790": "경기관련소비재",
  "110990": "IT",
  "111110": "경기관련소비재",
  "111380": "경기관련소비재",
  "111710": "경기관련소비재",
  "111770": "경기관련소비재",
  "112040": "커뮤니케이션서비스",
  "112290": "IT",
  "112610": "에너지",
  "113810": "경기관련소비재",
  "114090": "경기관련소비재",
  "114190": "IT",
  "114450": "건강관리",
  "114630": "경기관련소비재",
  "114810": "IT",
  "114840": "경기관련소비재",
  "115160": "IT",
  "115180": "건강관리",
  "115310": "IT",
  "115440": "IT",
  "115450": "건강관리",
  "115480": "건강관리",
  "115500": "IT",
  "115530": "IT",
  "115570": "소재",
  "115610": "IT",
  "117580": "유틸리티",
  "117670": "IT",
  "117730": "산업재",
  "118000": "건강관리",
  "118990": "경기관련소비재",
  "119500": "산업재",
  "119610": "건강관리",
  "119650": "산업재",
  "119830": "IT",
  "119850": "산업재",
  "120030": "소재",
  "120110": "소재",
  "120240": "소재",
  "121440": "경기관련소비재",
  "121600": "소재",
  "121800": "IT",
  "121850": "IT",
  "121890": "산업재",
  "122310": "건강관리",
  "122350": "경기관련소비재",
  "122450": "산업재",
  "122640": "IT",
  "122690": "경기관련소비재",
  "122870": "커뮤니케이션서비스",
  "122900": "산업재",
  "122990": "IT",
  "123010": "IT",
  "123040": "경기관련소비재",
  "123330": "경기관련소비재",
  "123410": "경기관련소비재",
  "123420": "커뮤니케이션서비스",
  "123570": "커뮤니케이션서비스",
  "123690": "경기관련소비재",
  "123700": "경기관련소비재",
  "123750": "경기관련소비재",
  "123840": "건강관리",
  "123860": "IT",
  "123890": "금융",
  "124500": "IT",
  "124560": "산업재",
  "125020": "산업재",
  "125210": "소재",
  "125490": "경기관련소비재",
  "126340": "산업재",
  "126560": "경기관련소비재",
  "126600": "소재",
  "126640": "경기관련소비재",
  "126700": "IT",
  "126720": "에너지",
  "126730": "IT",
  "126880": "에너지",
  "127120": "건강관리",
  "127710": "커뮤니케이션서비스",
  "127980": "IT",
  "128540": "경기관련소비재",
  "128660": "소재",
  "128820": "에너지",
  "128940": "건강관리",
  "129260": "산업재",
  "129890": "IT",
  "129920": "산업재",
  "130500": "경기관련소비재",
  "130580": "산업재",
  "130660": "유틸리티",
  "130740": "경기관련소비재",
  "131030": "건강관리",
  "131090": "IT",
  "131100": "커뮤니케이션서비스",
  "131180": "IT",
  "131220": "건강관리",
  "131290": "IT",
  "131370": "IT",
  "131400": "IT",
  "131760": "IT",
  "131970": "IT",
  "133750": "경기관련소비재",
  "133820": "소재",
  "134060": "경기관련소비재",
  "134380": "소재",
  "134580": "커뮤니케이션서비스",
  "134790": "산업재",
  "136150": "에너지",
  "136410": "소재",
  "136480": "필수소비재",
  "136490": "필수소비재",
  "136540": "IT",
  "137080": "IT",
  "137310": "건강관리",
  "137400": "IT",
  "137940": "경기관련소비재",
  "137950": "에너지",
  "138040": "금융",
  "138070": "산업재",
  "138080": "IT",
  "138360": "산업재",
  "138610": "건강관리",
  "138930": "금융",
  "139050": "IT",
  "139130": "금융",
  "139480": "경기관련소비재",
  "139670": "IT",
  "139990": "소재",
  "140070": "IT",
  "140410": "필수소비재",
  "140430": "IT",
  "140520": "소재",
  "140670": "산업재",
  "140860": "IT",
  "140910": "금융",
  "141000": "IT",
  "141080": "건강관리",
  "142210": "IT",
  "142280": "건강관리",
  "142760": "건강관리",
  "143160": "IT",
  "143210": "경기관련소비재",
  "143240": "산업재",
  "143540": "IT",
  "144510": "건강관리",
  "144960": "IT",
  "145020": "건강관리",
  "145170": "경기관련소비재",
  "145210": "경기관련소비재",
  "145270": "금융",
  "145720": "건강관리",
  "145990": "필수소비재",
  "146060": "경기관련소비재",
  "146320": "IT",
  "147760": "IT",
  "147830": "산업재",
  "148150": "IT",
  "148250": "IT",
  "148780": "IT",
  "148930": "IT",
  "149950": "IT",
  "149980": "건강관리",
  "150900": "IT",
  "151860": "경기관련소비재",
  "153460": "IT",
  "153490": "IT",
  "153710": "건강관리",
  "154030": "건강관리",
  "154040": "IT",
  "155650": "IT",
  "155660": "소재",
  "156100": "건강관리",
  "158430": "IT",
  "159010": "산업재",
  "159580": "경기관련소비재",
  "159910": "경기관련소비재",
  "160190": "산업재",
  "160550": "커뮤니케이션서비스",
  "160980": "IT",
  "161000": "소재",
  "161390": "경기관련소비재",
  "161580": "IT",
  "161890": "경기관련소비재",
  "162300": "소재",
  "163280": "소재",
  "163560": "소재",
  "163730": "IT",
  "166090": "IT",
  "166480": "건강관리",
  "168330": "경기관련소비재",
  "168360": "IT",
  "169330": "IT",
  "170030": "경기관련소비재",
  "170790": "IT",
  "170900": "건강관리",
  "170920": "IT",
  "171010": "IT",
  "171090": "IT",
  "171120": "산업재",
  "172670": "IT",
  "173130": "IT",
  "173940": "커뮤니케이션서비스",
  "174900": "건강관리",
  "175140": "IT",
  "175250": "경기관련소비재",
  "175330": "금융",
  "176750": "건강관리",
  "177350": "IT",
  "177830": "소재",
  "177900": "IT",
  "178320": "산업재",
  "178780": "경기관련소비재",
  "178920": "소재",
  "179290": "건강관리",
  "179530": "건강관리",
  "179900": "IT",
  "180400": "건강관리",
  "180640": "산업재",
  "181710": "IT",
  "182360": "커뮤니케이션서비스",
  "182400": "건강관리",
  "183190": "산업재",
  "183300": "IT",
  "183490": "건강관리",
  "184230": "IT",
  "185490": "건강관리",
  "185750": "건강관리",
  "186230": "산업재",
  "187220": "IT",
  "187270": "IT",
  "187420": "건강관리",
  "187660": "건강관리",
  "187790": "소재",
  "187870": "IT",
  "188040": "필수소비재",
  "188260": "건강관리",
  "189300": "IT",
  "189330": "IT",
  "189690": "IT",
  "189860": "산업재",
  "189980": "필수소비재",
  "190510": "IT",
  "190650": "금융",
  "191410": "IT",
  "191420": "건강관리",
  "192080": "커뮤니케이션서비스",
  "192250": "IT",
  "192390": "산업재",
  "192400": "경기관련소비재",
  "192410": "IT",
  "192440": "IT",
  "192650": "IT",
  "192820": "경기관련소비재",
  "193250": "IT",
  "194370": "경기관련소비재",
  "194480": "커뮤니케이션서비스",
  "194700": "건강관리",
  "195500": "필수소비재",
  "195870": "IT",
  "195940": "건강관리",
  "195990": "산업재",
  "196170": "건강관리",
  "196300": "건강관리",
  "196450": "IT",
  "196490": "IT",
  "196700": "소재",
  "197140": "IT",
  "198080": "IT",
  "198440": "산업재",
  "198940": "경기관련소비재",
  "199430": "산업재",
  "199480": "IT",
  "199550": "건강관리",
  "199730": "건강관리",
  "199800": "건강관리",
  "199820": "산업재",
  "200130": "건강관리",
  "200230": "건강관리",
  "200350": "커뮤니케이션서비스",
  "200470": "IT",
  "200670": "건강관리",
  "200710": "IT",
  "200780": "건강관리",
  "200880": "경기관련소비재",
  "201490": "커뮤니케이션서비스",
  "203400": "건강관리",
  "203450": "IT",
  "203650": "산업재",
  "203690": "필수소비재",
  "204020": "경기관련소비재",
  "204210": "금융",
  "204270": "IT",
  "204320": "경기관련소비재",
  "204610": "커뮤니케이션서비스",
  "204620": "금융",
  "204840": "건강관리",
  "205100": "IT",
  "205470": "건강관리",
  "205500": "커뮤니케이션서비스",
  "206400": "산업재",
  "206560": "커뮤니케이션서비스",
  "206640": "건강관리",
  "206650": "건강관리",
  "207760": "커뮤니케이션서비스",
  "207940": "건강관리",
  "208140": "필수소비재",
  "208350": "IT",
  "208370": "건강관리",
  "208640": "커뮤니케이션서비스",
  "208710": "IT",
  "208860": "경기관련소비재",
  "209640": "IT",
  "210120": "커뮤니케이션서비스",
  "210540": "산업재",
  "210980": "금융",
  "211050": "금융",
  "211270": "IT",
  "212560": "경기관련소비재",
  "212710": "IT",
  "213420": "IT",
  "213500": "소재",
  "214150": "건강관리",
  "214180": "IT",
  "214260": "경기관련소비재",
  "214270": "커뮤니케이션서비스",
  "214320": "커뮤니케이션서비스",
  "214330": "경기관련소비재",
  "214370": "건강관리",
  "214390": "건강관리",
  "214420": "경기관련소비재",
  "214430": "산업재",
  "214450": "건강관리",
  "214610": "건강관리",
  "214680": "건강관리",
  "215000": "경기관련소비재",
  "215090": "산업재",
  "215100": "경기관련소비재",
  "215200": "경기관련소비재",
  "215360": "경기관련소비재",
  "215380": "건강관리",
  "215480": "경기관련소비재",
  "215600": "건강관리",
  "215790": "IT",
  "216050": "커뮤니케이션서비스",
  "216080": "건강관리",
  "217190": "IT",
  "217270": "커뮤니케이션서비스",
  "217330": "건강관리",
  "217480": "경기관련소비재",
  "217500": "IT",
  "217590": "산업재",
  "217620": "경기관련소비재",
  "217730": "건강관리",
  "217820": "IT",
  "218150": "필수소비재",
  "218410": "IT",
  "219130": "IT",
  "219420": "IT",
  "219550": "경기관련소비재",
  "219750": "건강관리",
  "220100": "건강관리",
  "220180": "IT",
  "220260": "소재",
  "221800": "건강관리",
  "221840": "산업재",
  "221980": "소재",
  "222040": "건강관리",
  "222080": "IT",
  "222110": "건강관리",
  "222160": "IT",
  "222420": "소재",
  "222800": "IT",
  "222810": "소재",
  "222980": "필수소비재",
  "223250": "건강관리",
  "223310": "필수소비재",
  "224060": "산업재",
  "224110": "IT",
  "225190": "IT",
  "225220": "건강관리",
  "225430": "필수소비재",
  "225530": "산업재",
  "225570": "커뮤니케이션서비스",
  "225590": "경기관련소비재",
  "226320": "경기관련소비재",
  "226330": "건강관리",
  "226340": "경기관련소비재",
  "226400": "건강관리",
  "226590": "IT",
  "226950": "건강관리",
  "227100": "산업재",
  "227610": "경기관련소비재",
  "227840": "필수소비재",
  "227950": "IT",
  "228340": "산업재",
  "228670": "건강관리",
  "228760": "건강관리",
  "228850": "건강관리",
  "229000": "건강관리",
  "229640": "산업재",
  "230240": "IT",
  "230360": "경기관련소비재",
  "230980": "산업재",
  "232140": "IT",
  "232680": "IT",
  "232830": "IT",
  "234030": "IT",
  "234080": "건강관리",
  "234100": "경기관련소비재",
  "234300": "IT",
  "234340": "IT",
  "234690": "건강관리",
  "234920": "건강관리",
  "235980": "건강관리",
  "236200": "IT",
  "236810": "커뮤니케이션서비스",
  "237690": "건강관리",
  "237750": "산업재",
  "237820": "커뮤니케이션서비스",
  "237880": "경기관련소비재",
  "238090": "IT",
  "238120": "건강관리",
  "238200": "건강관리",
  "238490": "IT",
  "239340": "커뮤니케이션서비스",
  "239610": "건강관리",
  "239890": "IT",
  "240550": "건강관리",
  "240600": "IT",
  "240810": "IT",
  "241520": "금융",
  "241560": "산업재",
  "241590": "경기관련소비재",
  "241690": "경기관련소비재",
  "241710": "경기관련소비재",
  "241770": "IT",
  "241790": "IT",
  "241820": "건강관리",
  "241840": "커뮤니케이션서비스",
  "242040": "IT",
  "243070": "건강관리",
  "243840": "IT",
  "244460": "건강관리",
  "244920": "금융",
  "245620": "건강관리",
  "246250": "건강관리",
  "246690": "금융",
  "246710": "건강관리",
  "246720": "건강관리",
  "246960": "건강관리",
  "247540": "IT",
  "247660": "소재",
  "248070": "IT",
  "248170": "필수소비재",
  "249420": "건강관리",
  "250000": "필수소비재",
  "250060": "IT",
  "250930": "IT",
  "251120": "건강관리",
  "251270": "커뮤니케이션서비스",
  "251370": "소재",
  "251630": "산업재",
  "251970": "소재",
  "252500": "경기관련소비재",
  "252990": "IT",
  "253450": "커뮤니케이션서비스",
  "253590": "IT",
  "253840": "건강관리",
  "254120": "IT",
  "254490": "IT",
  "255220": "산업재",
  "255440": "IT",
  "256150": "경기관련소비재",
  "256630": "IT",
  "256840": "건강관리",
  "256940": "소재",
  "257370": "IT",
  "257720": "경기관련소비재",
  "258610": "IT",
  "258790": "IT",
  "258830": "건강관리",
  "259630": "IT",
  "259960": "커뮤니케이션서비스",
  "260660": "건강관리",
  "260930": "경기관련소비재",
  "260970": "필수소비재",
  "261200": "건강관리",
  "261520": "IT",
  "261780": "건강관리",
  "262260": "IT",
  "262840": "IT",
  "263020": "경기관련소비재",
  "263050": "건강관리",
  "263600": "IT",
  "263690": "건강관리",
  "263700": "건강관리",
  "263720": "커뮤니케이션서비스",
  "263750": "커뮤니케이션서비스",
  "263770": "소재",
  "263800": "IT",
  "263810": "IT",
  "263860": "IT",
  "263920": "소재",
  "264450": "IT",
  "264660": "IT",
  "264850": "IT",
  "264900": "필수소비재",
  "265520": "IT",
  "265560": "경기관련소비재",
  "265740": "경기관련소비재",
  "267250": "산업재",
  "267260": "산업재",
  "267270": "산업재",
  "267290": "유틸리티",
  "267320": "IT",
  "267790": "경기관련소비재",
  "267850": "IT",
  "267980": "필수소비재",
  "268280": "소재",
  "269620": "IT",
  "270520": "에너지",
  "270660": "경기관련소비재",
  "270870": "건강관리",
  "271560": "필수소비재",
  "271830": "IT",
  "271940": "경기관련소비재",
  "271980": "건강관리",
  "272110": "IT",
  "272210": "산업재",
  "272290": "IT",
  "272450": "산업재",
  "272550": "소재",
  "273060": "커뮤니케이션서비스",
  "273640": "IT",
  "274090": "산업재",
  "274400": "IT",
  "275630": "IT",
  "276040": "IT",
  "276730": "필수소비재",
  "277070": "금융",
  "277410": "필수소비재",
  "277810": "산업재",
  "277880": "IT",
  "278280": "IT",
  "278470": "경기관련소비재",
  "278650": "건강관리",
  "279600": "IT",
  "280360": "필수소비재",
  "281740": "소재",
  "281820": "IT",
  "282330": "경기관련소비재",
  "282720": "에너지",
  "282880": "산업재",
  "284620": "건강관리",
  "284740": "경기관련소비재",
  "285130": "소재",
  "285490": "IT",
  "285800": "소재",
  "286750": "소재",
  "286940": "IT",
  "287840": "건강관리",
  "288330": "건강관리",
  "288620": "IT",
  "288980": "IT",
  "289010": "경기관련소비재",
  "289080": "금융",
  "289220": "커뮤니케이션서비스",
  "289930": "산업재",
  "290090": "IT",
  "290120": "경기관련소비재",
  "290270": "IT",
  "290520": "IT",
  "290550": "IT",
  "290560": "IT",
  "290650": "건강관리",
  "290660": "건강관리",
  "290670": "IT",
  "290690": "IT",
  "290720": "필수소비재",
  "290740": "IT",
  "291230": "커뮤니케이션서비스",
  "291650": "건강관리",
  "291810": "IT",
  "293480": "건강관리",
  "293490": "커뮤니케이션서비스",
  "293580": "금융",
  "293780": "건강관리",
  "293940": "금융",
  "294090": "건강관리",
  "294140": "소재",
  "294570": "IT",
  "294630": "산업재",
  "294870": "산업재",
  "295310": "소재",
  "296640": "IT",
  "297090": "산업재",
  "297570": "IT",
  "297890": "IT",
  "298000": "소재",
  "298020": "경기관련소비재",
  "298040": "산업재",
  "298050": "소재",
  "298060": "건강관리",
  "298380": "건강관리",
  "298540": "경기관련소비재",
  "298690": "산업재",
  "298830": "IT",
  "299030": "IT",
  "299170": "건강관리",
  "299660": "건강관리",
  "299900": "커뮤니케이션서비스",
  "300080": "커뮤니케이션서비스",
  "300120": "IT",
  "300720": "산업재",
  "301300": "IT",
  "302430": "IT",
  "302440": "건강관리",
  "302550": "건강관리",
  "303030": "IT",
  "303360": "건강관리",
  "303530": "IT",
  "303810": "건강관리",
  "304100": "IT",
  "304360": "건강관리",
  "304840": "건강관리",
  "305090": "건강관리",
  "306040": "경기관련소비재",
  "306200": "소재",
  "306620": "IT",
  "307180": "IT",
  "307280": "건강관리",
  "307750": "건강관리",
  "307870": "IT",
  "307930": "금융",
  "307950": "IT",
  "308080": "건강관리",
  "308100": "경기관련소비재",
  "308170": "경기관련소비재",
  "308430": "건강관리",
  "309710": "건강관리",
  "309930": "산업재",
  "309960": "금융",
  "310200": "커뮤니케이션서비스",
  "310210": "건강관리",
  "310870": "경기관련소비재",
  "311320": "IT",
  "311390": "필수소비재",
  "311690": "건강관리",
  "312610": "경기관련소비재",
  "313760": "IT",
  "314130": "건강관리",
  "314140": "건강관리",
  "314930": "건강관리",
  "315640": "IT",
  "316140": "금융",
  "317120": "IT",
  "317240": "필수소비재",
  "317330": "IT",
  "317400": "산업재",
  "317450": "건강관리",
  "317530": "커뮤니케이션서비스",
  "317690": "건강관리",
  "317770": "IT",
  "317830": "산업재",
  "317850": "산업재",
  "317870": "경기관련소비재",
  "318000": "소재",
  "318010": "건강관리",
  "318020": "IT",
  "318060": "건강관리",
  "318160": "경기관련소비재",
  "318410": "필수소비재",
  "319400": "산업재",
  "319660": "IT",
  "320000": "IT",
  "321260": "IT",
  "321370": "IT",
  "321550": "건강관리",
  "321820": "커뮤니케이션서비스",
  "322000": "에너지",
  "322180": "IT",
  "322310": "IT",
  "322510": "건강관리",
  "322780": "커뮤니케이션서비스",
  "323280": "IT",
  "323350": "IT",
  "323410": "금융",
  "323990": "건강관리",
  "326030": "건강관리",
  "327260": "산업재",
  "328130": "건강관리",
  "328380": "IT",
  "329180": "산업재",
  "330350": "건강관리",
  "330590": "금융",
  "330730": "금융",
  "330860": "IT",
  "331380": "IT",
  "331520": "커뮤니케이션서비스",
  "331740": "경기관련소비재",
  "331920": "건강관리",
  "332290": "소재",
  "332370": "IT",
  "332570": "IT",
  "333050": "IT",
  "333430": "산업재",
  "333620": "IT",
  "334890": "금융",
  "334970": "건강관리",
  "335810": "건강관리",
  "335870": "경기관련소비재",
  "336060": "IT",
  "336260": "IT",
  "336370": "IT",
  "336570": "건강관리",
  "336680": "경기관련소비재",
  "337930": "경기관련소비재",
  "338100": "금융",
  "338220": "건강관리",
  "338840": "건강관리",
  "339770": "필수소비재",
  "339950": "경기관련소비재",
  "340360": "IT",
  "340440": "소재",
  "340450": "건강관리",
  "340570": "건강관리",
  "340810": "IT",
  "340930": "IT",
  "342870": "경기관련소비재",
  "344820": "산업재",
  "344860": "경기관련소비재",
  "347000": "IT",
  "347700": "산업재",
  "347740": "건강관리",
  "347770": "IT",
  "347850": "건강관리",
  "347860": "IT",
  "347890": "IT",
  "348030": "커뮤니케이션서비스",
  "348080": "건강관리",
  "348150": "건강관리",
  "348210": "IT",
  "348340": "산업재",
  "348350": "IT",
  "348370": "IT",
  "348950": "금융",
  "350520": "금융",
  "351320": "IT",
  "351330": "IT",
  "351870": "커뮤니케이션서비스",
  "352090": "경기관련소비재",
  "352480": "경기관련소비재",
  "352700": "경기관련소비재",
  "352770": "건강관리",
  "352820": "커뮤니케이션서비스",
  "352910": "IT",
  "352940": "소재",
  "353190": "건강관리",
  "353200": "IT",
  "353590": "경기관련소비재",
  "353810": "필수소비재",
  "354200": "건강관리",
  "354320": "경기관련소비재",
  "355150": "IT",
  "355390": "IT",
  "355690": "IT",
  "356680": "IT",
  "356860": "IT",
  "356890": "IT",
  "357120": "금융",
  "357230": "건강관리",
  "357250": "금융",
  "357430": "금융",
  "357550": "소재",
  "357580": "IT",
  "357780": "IT",
  "357880": "IT",
  "358570": "건강관리",
  "359090": "건강관리",
  "360070": "IT",
  "360350": "IT",
  "361390": "산업재",
  "361570": "커뮤니케이션서비스",
  "361610": "IT",
  "361670": "IT",
  "362320": "경기관련소비재",
  "362990": "커뮤니케이션서비스",
  "363250": "건강관리",
  "363260": "커뮤니케이션서비스",
  "363280": "경기관련소비재",
  "364950": "IT",
  "365270": "건강관리",
  "365330": "산업재",
  "365340": "IT",
  "365550": "금융",
  "365590": "IT",
  "365900": "경기관련소비재",
  "366030": "경기관련소비재",
  "367000": "IT",
  "368600": "IT",
  "368770": "IT",
  "368970": "필수소비재",
  "369370": "커뮤니케이션서비스",
  "370090": "IT",
  "371950": "IT",
  "372170": "IT",
  "372320": "건강관리",
  "372800": "IT",
  "372910": "건강관리",
  "373110": "건강관리",
  "373160": "경기관련소비재",
  "373170": "IT",
  "373200": "IT",
  "373220": "IT",
  "375500": "산업재",
  "376180": "경기관련소비재",
  "376270": "건강관리",
  "376290": "IT",
  "376300": "커뮤니케이션서비스",
  "376900": "건강관리",
  "376930": "건강관리",
  "376980": "산업재",
  "377030": "IT",
  "377190": "금융",
  "377220": "건강관리",
  "377300": "IT",
  "377330": "IT",
  "377450": "산업재",
  "377460": "산업재",
  "377480": "IT",
  "377740": "건강관리",
  "378340": "IT",
  "378800": "건강관리",
  "378850": "경기관련소비재",
  "380540": "IT",
  "380550": "건강관리",
  "381620": "산업재",
  "381970": "경기관련소비재",
  "382150": "건강관리",
  "382480": "IT",
  "382800": "IT",
  "382840": "IT",
  "382900": "IT",
  "383220": "경기관련소비재",
  "383310": "산업재",
  "383800": "산업재",
  "383930": "건강관리",
  "384470": "건강관리",
  "387570": "건강관리",
  "388050": "산업재",
  "388210": "IT",
  "388610": "건강관리",
  "388720": "산업재",
  "388790": "IT",
  "388870": "건강관리",
  "389020": "IT",
  "389030": "건강관리",
  "389140": "커뮤니케이션서비스",
  "389260": "에너지",
  "389470": "건강관리",
  "389500": "산업재",
  "389650": "건강관리",
  "389680": "IT",
  "391710": "IT",
  "393210": "IT",
  "393890": "IT",
  "393970": "IT",
  "394280": "IT",
  "394800": "건강관리",
  "395400": "금융",
  "396270": "IT",
  "396300": "IT",
  "396470": "IT",
  "396690": "금융",
  "397030": "건강관리",
  "397810": "커뮤니케이션서비스",
  "398120": "건강관리",
  "399720": "IT",
  "400760": "금융",
  "402030": "IT",
  "402340": "산업재",
  "402490": "IT",
  "403490": "필수소비재",
  "403550": "산업재",
  "403850": "커뮤니케이션서비스",
  "403870": "IT",
  "404990": "금융",
  "405000": "건강관리",
  "405100": "IT",
  "405920": "필수소비재",
  "406820": "경기관련소비재",
  "407400": "경기관련소비재",
  "408900": "커뮤니케이션서비스",
  "408920": "커뮤니케이션서비스",
  "411080": "IT",
  "412350": "IT",
  "412540": "IT",
  "413390": "IT",
  "413630": "산업재",
  "413640": "IT",
  "415380": "산업재",
  "416180": "IT",
  "417010": "IT",
  "417180": "커뮤니케이션서비스",
  "417200": "IT",
  "417310": "금융",
  "417500": "IT",
  "417790": "IT",
  "417840": "IT",
  "417860": "IT",
  "417970": "산업재",
  "418250": "IT",
  "418420": "IT",
  "418470": "커뮤니케이션서비스",
  "418550": "산업재",
  "418620": "IT",
  "419050": "경기관련소비재",
  "419080": "IT",
  "419120": "IT",
  "419530": "커뮤니케이션서비스",
  "419540": "건강관리",
  "420570": "경기관련소비재",
  "420770": "IT",
  "424760": "IT",
  "424870": "건강관리",
  "424960": "경기관련소비재",
  "424980": "IT",
  "425040": "IT",
  "425420": "IT",
  "429270": "IT",
  "430690": "IT",
  "431190": "IT",
  "432320": "금융",
  "432430": "커뮤니케이션서비스",
  "432470": "IT",
  "432720": "IT",
  "432980": "건강관리",
  "434480": "IT",
  "435570": "필수소비재",
  "437730": "경기관련소비재",
  "438700": "IT",
  "439090": "경기관련소비재",
  "439260": "산업재",
  "439580": "건강관리",
  "440110": "IT",
  "440290": "금융",
  "440320": "산업재",
  "441270": "IT",
  "443060": "산업재",
  "443250": "커뮤니케이션서비스",
  "443670": "IT",
  "444530": "IT",
  "445090": "IT",
  "445180": "IT",
  "445680": "건강관리",
  "446070": "산업재",
  "446540": "IT",
  "446840": "IT",
  "448280": "산업재",
  "448710": "산업재",
  "448730": "금융",
  "448900": "경기관련소비재",
  "450080": "IT",
  "450330": "건강관리",
  "450520": "IT",
  "450950": "건강관리",
  "451220": "IT",
  "451250": "경기관련소비재",
  "451700": "금융",
  "451760": "산업재",
  "451800": "금융",
  "452160": "IT",
  "452190": "IT",
  "452200": "IT",
  "452260": "경기관련소비재",
  "452280": "산업재",
  "452300": "금융",
  "452400": "IT",
  "452430": "IT",
  "452450": "IT",
  "452980": "금융",
  "453340": "필수소비재",
  "453450": "유틸리티",
  "453860": "경기관련소비재",
  "454910": "산업재",
  "455180": "IT",
  "455900": "건강관리",
  "456010": "IT",
  "456040": "소재",
  "456070": "건강관리",
  "456160": "건강관리",
  "457190": "소재",
  "457370": "IT",
  "457550": "에너지",
  "457600": "경기관련소비재",
  "457940": "금융",
  "458650": "IT",
  "458870": "건강관리",
  "459100": "IT",
  "459510": "산업재",
  "459550": "IT",
  "460470": "건강관리",
  "460850": "소재",
  "460860": "소재",
  "460870": "소재",
  "460930": "산업재",
  "460940": "건강관리",
  "461030": "건강관리",
  "461300": "경기관련소비재",
  "462020": "금융",
  "462310": "경기관련소비재",
  "462350": "산업재",
  "462510": "건강관리",
  "462520": "소재",
  "462860": "IT",
  "462870": "커뮤니케이션서비스",
  "462980": "금융",
  "463020": "IT",
  "463480": "경기관련소비재",
  "464080": "IT",
  "464280": "건강관리",
  "464440": "금융",
  "464490": "건강관리",
  "464500": "IT",
  "464580": "커뮤니케이션서비스",
  "464680": "금융",
  "465320": "금융",
  "465480": "IT",
  "465770": "산업재",
  "466100": "산업재",
  "466410": "IT",
  "466690": "금융",
  "466910": "금융",
  "467930": "금융",
  "468530": "건강관리",
  "468760": "금융",
  "469480": "금융",
  "469610": "IT",
  "469750": "IT",
  "469880": "금융",
  "469900": "금융",
  "471050": "금융",
  "471820": "건강관리",
  "472220": "금융",
  "472230": "금융",
  "472850": "경기관련소비재",
  "473000": "금융",
  "473050": "금융",
  "473950": "금융",
  "473980": "커뮤니케이션서비스",
  "474170": "산업재",
  "474490": "금융",
  "474610": "산업재",
  "474650": "산업재",
  "474660": "금융",
  "474930": "금융",
  "475150": "에너지",
  "475230": "산업재",
  "475240": "금융",
  "475250": "금융",
  "475400": "산업재",
  "475430": "산업재",
  "475460": "경기관련소비재",
  "475560": "경기관련소비재",
  "475580": "경기관련소비재",
  "475660": "IT",
  "475830": "건강관리",
  "475960": "건강관리",
  "476040": "건강관리",
  "476060": "건강관리",
  "476080": "커뮤니케이션서비스",
  "476830": "건강관리",
  "477340": "금융",
  "477380": "금융",
  "477470": "금융",
  "477760": "금융",
  "478110": "금융",
  "478340": "산업재",
  "478390": "금융",
  "478440": "금융",
  "478560": "경기관련소비재",
  "479880": "금융",
  "479960": "산업재",
  "480370": "산업재",
  "481070": "경기관련소비재",
  "481850": "금융",
  "481890": "금융",
  "482520": "금융",
  "482630": "IT",
  "482680": "금융",
  "482690": "금융",
  "483650": "경기관련소비재",
  "484120": "IT",
  "484130": "금융",
  "484590": "산업재",
  "484810": "산업재",
  "484870": "산업재",
  "486630": "금융",
  "486990": "IT",
  "487360": "금융",
  "487570": "산업재",
  "487720": "금융",
  "487830": "금융",
  "488060": "금융",
  "488280": "IT",
  "488900": "산업재",
  "489210": "금융",
  "489460": "경기관련소비재",
  "489480": "금융",
  "489500": "IT",
  "489730": "금융",
  "489790": "IT",
  "490470": "IT",
  "491000": "건강관리",
  "492220": "금융",
  "493330": "IT",
  "493790": "금융",
  "494120": "건강관리",
  "496070": "금융",
  "498390": "금융",
  "499790": "경기관련소비재",
  "900070": "경기관련소비재",
  "900100": "경기관련소비재",
  "900110": "경기관련소비재",
  "900120": "건강관리",
  "900140": "경기관련소비재",
  "900250": "소재",
  "900260": "IT",
  "900270": "경기관련소비재",
  "900290": "소재",
  "900300": "경기관련소비재",
  "900310": "경기관련소비재",
  "900340": "필수소비재",
  "950130": "건강관리",
  "950140": "경기관련소비재",
  "950160": "건강관리",
  "950170": "경기관련소비재",
  "950190": "커뮤니케이션서비스",
  "950200": "건강관리",
  "950210": "건강관리",
  "950220": "건강관리",
  "950250": "IT",
};

// ticker(숫자/문자)·market → 섹터. 해외는 "해외", 미분류 KR은 "기타".
export function sectorOf(ticker, market) {
  const mk = String(market || "").toUpperCase();
  if (mk && !["KR", "KS", "KQ"].includes(mk)) return "해외";
  const code = String(ticker == null ? "" : ticker).replace(/\D/g, "").padStart(6, "0");
  if (KR_SECTOR[code]) return KR_SECTOR[code];
  // 우선주(코드 끝자리 5) → 보통주(끝자리 0) 섹터로 폴백
  if (code.endsWith("5") && KR_SECTOR[code.slice(0, 5) + "0"]) return KR_SECTOR[code.slice(0, 5) + "0"];
  return "기타";
}
